import Divider from '@material-ui/core/Divider';
import { makeStyles, styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { AI_ASSISTANT_TYPOGRAPHY_STYLES } from 'features/ai-assistant/constants';

export const useDrawerStyles = makeStyles(theme => ({
  assistantTypography: {
    ...AI_ASSISTANT_TYPOGRAPHY_STYLES
  },
  aiResponseContainer: {
    padding: theme.spacing(3)
  },
  drawerLarge: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxWidth: '80vw',
    minHeight: 0,
    width: '80vw'
  },
  grid: {
    flex: 1,
    height: '100%',
    minHeight: 0
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  leftContainer: {
    background: theme.palette.grey[50],
    borderRight: `1px solid ${theme.palette.divider}`,
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: theme.spacing(2)
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  rightContainer: {
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflowY: 'auto'
  },
  alert: { borderRadius: 0 }
}));

export const BodyText = styled(Typography)({
  whiteSpace: 'pre-wrap'
});

export const StyledDivider = styled(Divider)({
  margin: 0
});

export const LoaderContainer = styled('div')({
  minHeight: 200
});
